/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { interpolateLabel } from '@/utils/labels/interpolateLabel';

/**
 * Generates aria labels for quantity stepper controls in the cart.
 * Supports both concise and verbose variants, with template interpolation
 * for accessibility-friendly button labels.
 */
export const generateAriaLabelsForQtyStepper = ({
  template,
  productName,
  action,
  quantity,
  variant = 'verbose',
}: {
  template: string;
  action: string;
  productName: string | undefined | null;
  quantity: number | string | undefined | null;
  variant?: 'concise' | 'verbose';
}): string => {
  if (variant === 'concise') {
    return action;
  }

  if (
    !template.includes('${action}') ||
    !template.includes('${productName}') ||
    !template.includes('${quantity}')
  ) {
    return action;
  }

  return interpolateLabel(template, {
    action,
    productName,
    quantity,
  });
};
